var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 10.7V8C16.75 5.38 14.62 3.25 12 3.25C9.38 3.25 7.25 5.38 7.25 8V10.7C6.07 11.33 5.25 12.56 5.25 14V18C5.25 20.07 6.93 21.75 9 21.75H15C17.07 21.75 18.75 20.07 18.75 18V14C18.75 12.57 17.93 11.33 16.75 10.7ZM8.75 8C8.75 6.21 10.21 4.75 12 4.75C13.79 4.75 15.25 6.21 15.25 8V10.28C15.17 10.28 15.09 10.25 15 10.25H9C8.91 10.25 8.83 10.27 8.75 10.28V8ZM17.25 18C17.25 19.24 16.24 20.25 15 20.25H9C7.76 20.25 6.75 19.24 6.75 18V14C6.75 12.76 7.76 11.75 9 11.75H15C16.24 11.75 17.25 12.76 17.25 14V18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25C11.59 14.25 11.25 14.59 11.25 15V17C11.25 17.41 11.59 17.75 12 17.75C12.41 17.75 12.75 17.41 12.75 17V15C12.75 14.59 12.41 14.25 12 14.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.87aca0acb5094936989c3ca923b602b2.svg";
export { ForwardRef as ReactComponent };